import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import suitcss from '../../../helpers/suitcss';
import connectUniqueId from '../service/UniqueIdConnector';

import { hintShape, inputShape, metaShape } from '../../../propTypes/field';

import FieldWrapper from './FieldWrapper';

const componentName = 'FieldInputBirthday';
const allowedTypes = ['text', 'password', 'email', 'tel'];
const defaultType = 'text';

// Helper function to format birthday input as DD.MM.YYYY
function formatDateExpression(v) {
  // replace all invalid characters
  const dv = (v && v !== null) ? v.replace(/([^0-9.])/g, '').trim() : '';

  // split into date parts
  const m = dv.match(/^(3[01]|[12][0-9]|0?[1-9])(\.*)(1[0-2]|0?[1-9])?(\.*)(\d{1,4})?$/);
  if (m !== null) {
    const inpDay = (typeof m[1] !== 'undefined' ? m[1] : null);
    const dotDay = (typeof m[2] !== 'undefined' ? (m[2] === '.') : false);
    const inpMonth = (typeof m[3] !== 'undefined' ? m[3] : null);
    const dotMonth = (typeof m[4] !== 'undefined' ? (m[4] === '.') : false);
    const inpYear = (typeof m[5] !== 'undefined' ? m[5] : null);

    const day = parseInt(inpDay, 10);
    const month = parseInt(inpMonth, 10);

    // eslint-disable-next-line max-len
    const dayComplete = inpDay !== null && (inpDay.length === 2 || dotDay || parseInt(inpDay.substr(0, 1), 10) > 3);
    // eslint-disable-next-line max-len
    const monthComplete = inpMonth !== null && (dayComplete && (inpMonth.length === 2 || dotMonth || parseInt(inpMonth.substr(0, 1), 10) > 1));

    let de = '';
    if (dayComplete) {
      de = `${day < 10 ? `0${day.toString()}` : day}.`;
    } else {
      de = (inpDay !== null ? inpDay : '');
    }

    if (monthComplete) {
      de = `${de + (month < 10 ? `0${month.toString()}` : month)}.`;
    } else {
      de += (inpMonth !== null ? inpMonth : '');
    }

    de += (inpYear !== null ? inpYear : '');

    return de;
  }

  return v;
}

function FieldInputBirthday(props) {
  const {
    input,
    label,
    uniqueId,
    autocomplete,
    isReadOnly,
    maxLength,
    onInput,
    type: typeProp,
    onBlur,
    placeholder,
  } = props;

  const type = allowedTypes.find((t) => t === typeProp) ?? defaultType;

  // Birthdate input helper
  const lastKeyRef = useRef(null);

  function handleKeyDown(e) {
    lastKeyRef.current = e.key;
    if (input.onKeyDown) input.onKeyDown(e);
  }

  function handleInput(e) {
    const { value, name } = e.target;
    const validNames = ['birthday', 'birthdate', 'mnp_birthday', 'terminationDate'];
    if (validNames.includes(name)) {
      let formatted = value;
      if (lastKeyRef.current !== 'Backspace' && lastKeyRef.current !== 'Delete') {
        formatted = formatDateExpression(value);
      }
      if (input && input.onChange) {
        input.onChange(formatted);
      }
      e.target.value = formatted;
    }
    if (onInput) onInput(e);
  }

  return (
    <FieldWrapper
      componentName={componentName}
      {...props}
      withMessenger
      withToolTip={false}
    >
      {wrapperProvider => (
        <div className={suitcss({ componentName, descendantName: 'inner' })}>
          <label
            className={suitcss({
              componentName,
              descendantName: 'label',
            })}
            htmlFor={uniqueId}
          >
            <span>
              {label}
              {
                !wrapperProvider.isRequired
                && !props.hideOptionalHint
                && wrapperProvider.getIsOptionalElement()
              }
            </span>
            <div
              className={suitcss({
                componentName,
                descendantName: 'iconWrapper',
              })}
            >
              <input
                autoComplete={autocomplete}
                maxLength={maxLength}
                className={suitcss({
                  componentName,
                  descendantName: 'input',
                })}
                id={uniqueId}
                type={type}
                onKeyDown={handleKeyDown}
                onInput={e => {
                  handleInput(e);
                }}
                onBlur={onBlur}
                readOnly={isReadOnly}
                placeholder={placeholder}
                {...input}
              />
            </div>
          </label>
        </div>
      )}
    </FieldWrapper>
  );
}

FieldInputBirthday.propTypes = {
  uniqueId: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string,
  hint: hintShape,
  input: inputShape,
  meta: metaShape,
  raw: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  utitilies: PropTypes.array,
  theme: PropTypes.oneOf(['default', 'compact']),
  autocomplete: PropTypes.string,
  onInput: PropTypes.func,
  onBlur: PropTypes.func,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  maxlength: PropTypes.number,
  hideOptionalHint: PropTypes.bool,
};

FieldInputBirthday.defaultProps = {
  type: 'text',
  meta: {},
  input: {},
  theme: 'default',
};

export default connectUniqueId('fi')(FieldInputBirthday);
